var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1358_1723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5131 20.5086C14.3591 26.6823 3.75744 24.3172 0.763082 16.1782C-2.76912 6.57923 6.58333 -2.76805 16.1818 0.762127C24.3352 3.76094 26.6684 14.3343 20.5131 20.5086ZM11.3044 1.79881C3.27491 2.34925 -1.01065 11.6037 3.78923 18.1098C8.20702 24.0992 17.4101 23.4458 20.9912 16.9505C24.9004 9.86025 19.344 1.24837 11.3037 1.79881H11.3044Z",
    fill: "#62C776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8083 7.6416C17.4592 7.29265 16.8941 7.29265 16.545 7.6416L9.74894 14.4363L7.49967 12.1875C7.14048 11.8284 6.55813 11.8284 6.19957 12.1875C5.84038 12.5466 5.84038 13.1288 6.19957 13.4873L9.0617 16.3488C9.19774 16.4848 9.36622 16.5694 9.54232 16.6024C9.82586 16.6596 10.1323 16.5789 10.3523 16.359L17.8083 8.90455C18.1573 8.5556 18.1573 7.99055 17.8083 7.6416Z",
    fill: "#62C776"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1358_1723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletado);
export default __webpack_public_path__ + "static/media/completado.f96d50c57ac3bf80ecd11551b1d6f78b.svg";
export { ForwardRef as ReactComponent };